<template>
  <v-container class="ma-0 pa-0" dark>
    <v-expand-transition>
      <v-card width="250" v-if="showSettings">
        <v-subheader>Audio Devices</v-subheader>
        <v-col>
          <v-select
            v-model="selectedInputDevice"
            :items="inputDevices"
            label="Microphone"
            outlined
            hide-details
            dense
            prepend-inner-icon="fad fa-microphone"
          />
        </v-col>

        <v-col>
          <v-select
            v-model="selectedOutputSpeakerDevice"
            :items="outputDevices"
            label="Speaker"
            outlined
            hide-details
            dense
            prepend-inner-icon="fad fa-headset"
          />
        </v-col>

        <v-col>
          <v-select
            v-model="selectedOutputRingToneDevice"
            :items="outputDevices"
            label="Ringer"
            outlined
            hide-details
            dense
            prepend-inner-icon="fad fa-phone-volume"
          />
        </v-col>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn small text @click="logout" color="error"><v-icon class="mr-2">fad fa-sign-out</v-icon> Log out</v-btn>
          <v-spacer></v-spacer>
          <v-btn small text @click="showSettings = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-expand-transition>
    <v-list nav dense width="250" class="py-0" dark color="primary" style="border-radius: 0;">
      <v-list-item two-line>
        <v-list-item-avatar v-if="PlatformUser">
          <abf-owner-avatar :user="CurrentUser"></abf-owner-avatar>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ UserName }}</v-list-item-title>
          <v-list-item-subtitle v-if="PlatformUser">{{ status.text | capitalise }}</v-list-item-subtitle>
          <v-list-item-subtitle v-else>{{ CurrentUser.email }}</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action @click="showSettings = !showSettings" v-if="PlatformUser">
          <v-icon v-if="showSettings">fad fa-cog fa-rotate-90</v-icon>
          <v-icon v-else>fad fa-cog</v-icon>
        </v-list-item-action>

        <v-list-item-action @click="setupTwilioDevice" v-if="PlatformUser">
          <v-icon :color="status.color">{{ status.icon }}</v-icon>
        </v-list-item-action>

        <v-list-item-action @click="logout" v-else><v-icon>fad fa-sign-out</v-icon></v-list-item-action>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
import AbfOwnerAvatar from './Abf/AbfOwnerAvatar';
import { mapActions, mapGetters } from 'vuex';
import diallerApi from '../api/dialler';
import TwilioDevice from '../plugins/twilio';
import Echo from '../plugins/echo';

export default {
  name: 'UserStatus',
  components: { AbfOwnerAvatar },
  props: {
    CurrentUser: {},
    PlatformUser: {},
    UserName: {}
  },
  data: () => ({
    showSettings: false
  }),
  computed: {
    ...mapGetters(['Twilio', 'UserId']),
    status: function() {
      return this.Twilio.offline
        ? { text: 'Not connected', icon: 'fad fa-phone-slash', color: 'error' }
        : { text: TwilioDevice.status(), icon: 'fad fa-phone', color: 'success' };
    },
    inputDevices: function() {
      if (this.Twilio.offline) {
        return [];
      }
      const devices = [];
      TwilioDevice.audio.availableInputDevices.forEach((device, id) => {
        devices.push({ text: device.label, value: id });
      });
      return devices;
    },
    outputDevices: function() {
      if (this.Twilio.offline) {
        return [];
      }
      const devices = [];
      TwilioDevice.audio.availableOutputDevices.forEach((device, id) => {
        devices.push({ text: device.label, value: id });
      });
      return devices;
    },
    selectedInputDevice: {
      get() {
        return this.Twilio.settings.selectedInputDevice;
      },
      set(device) {
        this.selectTwilioInputDevice(device);
      }
    },
    selectedOutputRingToneDevice: {
      get() {
        return this.Twilio.settings.selectedOutputRingToneDevice;
      },
      set(device) {
        this.selectTwilioOutputRingToneDevice(device);
      }
    },
    selectedOutputSpeakerDevice: {
      get() {
        return this.Twilio.settings.selectedOutputSpeakerDevice;
      },
      set(device) {
        this.selectTwilioOutputSpeakerDevice(device);
      }
    }
  },
  methods: {
    ...mapActions([
      'addCallToQueue',
      'addNotification',
      'logout',
      'removeCallFromQueue',
      'selectTwilioInputDevice',
      'selectTwilioOutputRingToneDevice',
      'selectTwilioOutputSpeakerDevice',
      'setTwilioDeviceMute',
      'setTwilioOfflineState',
      'setTwilioOnPhoneState'
    ]),
    sendDigit: function(digit) {
      this.Twilio.connection.sendDigits(digit);
    },
    setupTwilioDevice: function() {
      diallerApi.getDeviceToken().then(response => {
        TwilioDevice.setup(response.token, {
          closeProtection: true,
          codecPreferences: ['opus', 'pcmu'],
          enableRingingState: true,
          name: this.UserName
        });
      });
    },
    listenForNewCalls() {
      Echo.private(`Dialler.PhoneCall.${this.UserId}`)
        .listen('PhoneCall\\PhoneCallAssigned', event => {
          this.addCallToQueue(event.phoneCall);
        })
        .listen('PhoneCall\\PhoneCallUnassigned', event => {
          this.removeCallFromQueue(event.id);
        })
        .listen('PhoneCall\\PhoneCallCompleted', event => {
          this.removeCallFromQueue(event.phoneCall.id);
        })
        .listen('PhoneCall\\PhoneCallOverdue', event => {
          this.markPhoneCallOverdue(event.phoneCall.id);
        });
    }
  },
  filters: {
    capitalise: function(value) {
      if (!value) {
        return '';
      }
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  mounted() {
    this.listenForNewCalls();
  }
};
</script>
